import { HttpClientModule } from "@angular/common/http";
import { ApplicationRef, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule, Routes } from '@angular/router';
import { LazyLoaderService } from './lazy-loader.service';
import { SharedModule } from './shared/shared.module';

const routes: Routes = [
  { loadChildren: () => import('./secure-form/secure-form-app.module').then(m => m.SecureFormAppModule) }, 
  { loadChildren: () => import('./pre-chat/pre-chat-app.module').then(m => m.PreChatAppModule) }
];

@NgModule({	
	imports: [
    SharedModule,
		BrowserModule, 
		BrowserAnimationsModule,
  	HttpClientModule,
    RouterModule.forChild(routes),
	],
	providers: [],
})
export class AppModule {
	constructor(private lazyLoaderService: LazyLoaderService) { }

  ngDoBootstrap(appRef: ApplicationRef) {
    const modules = document.querySelectorAll('[data-module-path]');
    for (const i in modules) {
      if (modules.hasOwnProperty(i)) {
        const modulePath = modules[i].getAttribute('data-module-path');
        if (modulePath) {
          switch(modulePath) {
            case "./secure-form/secure-form-app.module#SecureFormAppModule":
              this.lazyLoaderService.loadModule(() => import('./secure-form/secure-form-app.module').then(m => m.SecureFormAppModule), appRef);
              break;
            case "./pre-chat/pre-chat-app.module#PreChatAppModule":
              this.lazyLoaderService.loadModule(() => import('./pre-chat/pre-chat-app.module').then(m => m.PreChatAppModule), appRef);
          }
          console.log(`Module ${{modulePath}} is loaded.`);
        }
      }
    }
  }
}
